module.exports = __webpack_public_path__ + "img/knights-logo-full-white.eddfb2aa.png";